import React from 'react';

import { iconBaseProps, type IconProps } from './IconBase';

const PlusIcon: React.FC<IconProps> = props => (
  <svg {...iconBaseProps} {...props}>
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

export default PlusIcon;
